module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/gray/mastercard-39c53b2343230c84e764f8a478bbb786.svg";